var React = require('react');

function BreadcrumbsArrow (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Arrow---Right-2","transform":"translate(0 15.351) rotate(-90)"},React.createElement("path",{"id":"Stroke-1","d":"M.218.218A.743.743,0,0,1,1.185.146l.083.072L7.675,6.625,14.083.218A.743.743,0,0,1,15.05.146l.083.072a.743.743,0,0,1,.072.967l-.072.083L8.2,8.2a.743.743,0,0,1-.967.072L7.15,8.2.218,1.268A.743.743,0,0,1,.218.218Z","transform":"translate(0)","fill":"rgba(0,0,0,0.7)"})));
}

BreadcrumbsArrow.defaultProps = {"width":"8.418","height":"15.351","viewBox":"0 0 8.418 15.351"};

module.exports = BreadcrumbsArrow;

BreadcrumbsArrow.default = BreadcrumbsArrow;
